import {
  EXTERNAL_API_UPDATE_EXTERNAL_API_BEGIN,
  EXTERNAL_API_UPDATE_EXTERNAL_API_SUCCESS,
  EXTERNAL_API_UPDATE_EXTERNAL_API_FAILURE,
  EXTERNAL_API_UPDATE_EXTERNAL_API_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getCookie, updateUserIpInCookie } from '../../../common/utils/api_utils';

export function updateExternalApi(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: EXTERNAL_API_UPDATE_EXTERNAL_API_BEGIN,
    });
    const { projectId, version, externalApiId } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const config = builderSurfaceJsonContentHeader(projectId, userIp);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.put(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/external-api/${externalApiId}`,
        args,
        config,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: EXTERNAL_API_UPDATE_EXTERNAL_API_SUCCESS,
              data: res,
            });
            toast.success('Updated Successfully !', {});
            resolve(res);
          } else {
            dispatch({
              type: EXTERNAL_API_UPDATE_EXTERNAL_API_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Updation Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: EXTERNAL_API_UPDATE_EXTERNAL_API_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Updation Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissUpdateExternalApiError() {
  return {
    type: EXTERNAL_API_UPDATE_EXTERNAL_API_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EXTERNAL_API_UPDATE_EXTERNAL_API_BEGIN:
      return {
        ...state,
        updateExternalApiPending: true,
        updateExternalApiError: null,
      };

    case EXTERNAL_API_UPDATE_EXTERNAL_API_SUCCESS:
      return {
        ...state,
        updateExternalApiPending: false,
        updateExternalApiError: null,
      };

    case EXTERNAL_API_UPDATE_EXTERNAL_API_FAILURE:
      return {
        ...state,
        updateExternalApiPending: false,
        updateExternalApiError: action.data.error,
      };

    case EXTERNAL_API_UPDATE_EXTERNAL_API_DISMISS_ERROR:
      return {
        ...state,
        updateExternalApiError: null,
      };

    default:
      return state;
  }
}
